export function getSystem() {
  const u = navigator.userAgent;
  let system = "unknow";
  if (u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1) {
    system = "ios"; // ios
  } else if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    system = "android"; // android
  }

  return system;
}

export function getVideoBase64(url) {
  return new Promise(function (resolve, reject) {
    let dataURL = "";
    const video = document.createElement("video");
    video.setAttribute("crossOrigin", "anonymous");
    video.setAttribute("src", url);
    video.setAttribute("width", 400);
    video.setAttribute("height", 240);
    video.setAttribute("preload", "auto");
    video.addEventListener("loadeddata", function () {
      const canvas = document.createElement("canvas");
      const width = video.width;
      const height = video.height;
      canvas.width = width;
      canvas.height = height;
      canvas.getContext("2d").drawImage(video, 0, 0, width, height);
      dataURL = canvas.toDataURL("image/jpeg");
      resolve(dataURL);
    });
    video.addEventListener("error", function () {
      resolve("");
    });
  });
}

export function loadJS(url, callback) {
  let script = document.createElement("script"),
    fn = callback || function () {};

  script.type = "text/javascript";

  //IE

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;

        fn();
      }
    };
  } else {
    //其他浏览器

    script.onload = function () {
      fn();
    };
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

// 视频播放列表
export function videoReady() {
  let _videos = document.getElementsByTagName("video");
  for (let i = 0; i < _videos.length; i++) {
    wxVideoPlay(_videos[i]);
  }
}

//  微信浏览器视频播放
export function wxVideoPlay(videoDom) {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    // IOS自动播放
    if (ua.indexOf("iphone") > -1 || ua.indexOf("mac") > -1) {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          videoDom.play();
        },
        false
      );
    } else {
      // 安卓任何页面任何一个地方点击触发播放
      let timer = null;
      timer = setInterval(() => {
        videoDom.controls = true;
        videoDom.play();
        videoDom.onplay = function () {
          clearInterval(timer);
        };
      }, 500);
    }
  }
}

// 视频全屏
export function launchFullscreen(element) {
  //此方法不可以在異步任務中執行，否則火狐無法全屏
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  } else if (element.oRequestFullscreen) {
    element.oRequestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullScreen();
  } else {
    let docHtml = document.documentElement;
    let docBody = document.body;
    let videobox = element;
    let cssText = "width:100%;height:100%;overflow:hidden;";
    docHtml.style.cssText = cssText;
    docBody.style.cssText = cssText;
    videobox.style.cssText = cssText + ";" + "margin:0px;padding:0px;";
    document.IsFullScreen = true;
  }
}
// 退出全屏
export function exitFullscreen(element) {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.oRequestFullscreen) {
    document.oCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else {
    let docHtml = document.documentElement;
    let docBody = document.body;
    let videobox = element;
    docHtml.style.cssText = "";
    docBody.style.cssText = "";
    videobox.style.cssText = "";
    document.IsFullScreen = false;
  }
}

export function dealConfig(list, type) {
  let newList = {};
  list.forEach((item) => {
    newList[item.name] = item.value || "";
  });
  // 下载链接灰度分配
  if (type && type == 1) {
    let _p = newList["new_percent"];
    if (!isNaN(Number(_p))) {
      let _r = Math.floor(Math.random() * 100 + 1); //生成0-100随机数
      if (_r <= Number(_p)) {
        Object.keys(newList).forEach((key) => {
          if (
            Object.hasOwnProperty.call(newList, key + "_new") &&
            newList[key + "_new"] != ""
          ) {
            newList[key] = newList[key + "_new"];
          }
        });
      }
    }
  }
  return newList;
}

export const Throttle = (fn, delay = 500) => {
  let lastTime = 0;
  let timer = null;

  return function () {
    const _this = this;
    const _arguments = arguments;
    const now = new Date().getTime();
    clearTimeout(timer);
    // 判断上次触发的时间和本次触发的时间差是否小于delay,创建一个timer
    if (now - lastTime < delay) {
      timer = setTimeout(function () {
        lastTime = now;
        fn.apply(_this, _arguments);
      }, delay);
    } else {
      // 否则可以直接执行
      lastTime = now;
      fn.apply(_this, _arguments);
    }
  };
};
